import React from 'react'
import styled from 'styled-components'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'

import { Box } from 'components/Box'

import syntaxTheme from './syntaxTheme'

const Root = styled(Box)`
  overflow: hidden;
  & > pre {
    margin: 0;
  }
`

const borderRadius = ['unset', 'unset', 3]

const CodeBlock = (props) => {
  const { language, codeString } = props
  return (
    <Root borderRadius={borderRadius}>
      <SyntaxHighlighter style={syntaxTheme} language={language}>
        {codeString}
      </SyntaxHighlighter>
    </Root>
  )
}

export default CodeBlock
